import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import AddressDropdown from './addressDropdown'
import * as OverpanelActions from '../actions/overpanels'
import * as AddressActions from '../actions/address'
import { FLOW_TYPES } from '../constants'
import { SHIPPING_TYPES } from '../../../../lib/constants'

class ShippingAddressDropdown extends React.Component {
  static propTypes = {
    hasNoAddressNeededOption: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    env: PropTypes.string.isRequired,
    handleSelectAddress: PropTypes.func.isRequired,
    selectedAddress: PropTypes.shape({
      id: PropTypes.string,
    }),
    onAddressChanged: PropTypes.func,
    dir: PropTypes.string.isRequired,
    validateAmount: PropTypes.func,
  }

  static defaultProps = {
    hasNoAddressNeededOption: true,
    handleSelectAddress: () => {},
  }

  handleAddAddress = () => {
    const { env = '', validateAmount = () => {} } = this.props
    if (env === 'donate' && !validateAmount()) {
      return
    }
    this.props.dispatch(
      OverpanelActions.toggleAddShippingAddressOverpanel({ show: true })
    )
  }

  handleSelectAddress = id => {
    const {
      onAddressChanged = () => {},
      validateAmount = () => {},
      dispatch,
      env = '',
    } = this.props
    if (env === 'donate' && !validateAmount()) {
      return
    }
    dispatch(AddressActions.changeSelectedShippingAddress(id))
    onAddressChanged(id)
  }

  render() {
    // TODO: avoid env. specific stuff in components
    const isDonate = this.props.env === 'donate'
    const selectElementId = isDonate ? 'mailingAddress' : 'shippingAddress'
    const yourAddressContentKey = `label.your${
      isDonate ? 'Mailing' : 'Shipping'
    }Address`
    const addNewAddressContentKey = `label.addNew${
      isDonate ? 'Mailing' : 'Shipping'
    }Address`
    return (
      <AddressDropdown
        {...this.props}
        handleAddAddress={this.handleAddAddress}
        handleSelectAddress={this.handleSelectAddress}
        selectElementId={selectElementId}
        yourAddressContentKey={yourAddressContentKey}
        addNewAddressContentKey={addNewAddressContentKey}
        shouldRenderLabel={true}
        hasNoAddressNeededOption={this.props.hasNoAddressNeededOption}
      />
    )
  }
}

function noAddressNeededOption(defaultOption, env, shippingType, isCharity) {
  if (env === 'donate') {
    return defaultOption
  }
  if (
    env === FLOW_TYPES.PPSHOPS &&
    (shippingType === SHIPPING_TYPES.FLAT_RATE ||
      shippingType === SHIPPING_TYPES.FREE)
  ) {
    return false
  }
  return !isCharity
}

export default connect(
  (
    { address, server, recipient, transaction },
    { hasNoAddressNeededOption }
  ) => ({
    addressEntryFormat: address.addressEntryFormat,
    addresses: address.addresses,
    selectedAddress: address.selectedShippingAddress,
    env: server.env,
    dir: server.directionality,
    hasNoAddressNeededOption: noAddressNeededOption(
      hasNoAddressNeededOption,
      server.env,
      transaction.shippingType,
      recipient.isCharity
    ),
  })
)(ShippingAddressDropdown)
